export interface ReportTemplate { id: number; name: string; description: string; createdAt: string; updatedAt: string }
export interface MappingPlan {
  auto: Record<string, number>
  ambiguous: Array<{ sourceType: string; candidates: Array<{ id: number; label: string }> }>
  missing: string[]
}

async function json(res: Response) {
  const body = await res.json().catch(() => ({}))
  if (!res.ok || body?.error) throw new Error(body?.error || `HTTP ${res.status}`)
  return body.data
}

export async function listTemplates(): Promise<ReportTemplate[]> {
  return json(await fetch('/api/report-templates', { credentials: 'include' }))
}

export async function renameTemplate(id: number, name: string): Promise<ReportTemplate> {
  return json(await fetch(`/api/report-templates/${id}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  }))
}

export async function deleteTemplate(id: number): Promise<void> {
  await json(await fetch(`/api/report-templates/${id}`, { method: 'DELETE', credentials: 'include' }))
}

export async function saveReportAsTemplate(reportId: number, name: string): Promise<ReportTemplate> {
  return json(await fetch(`/api/report-templates/from-report/${reportId}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  }))
}

export async function getMappingPlan(templateId: number, projectId: number): Promise<MappingPlan> {
  return json(await fetch(`/api/report-templates/${templateId}/mapping-plan?projectId=${projectId}`, {
    credentials: 'include',
  }))
}

export async function createReportFromTemplate(projectId: number, templateId: number, mapping?: Record<string, number>) {
  return json(await fetch(`/api/reporting/clients/${projectId}/reports/from-template/${templateId}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(mapping ? { mapping } : {}),
  }))
}

export async function startEditSession(templateId: number, projectId: number): Promise<{ reportId: number; projectId: number }> {
  return json(await fetch(`/api/report-templates/${templateId}/edit-session`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId }),
  }))
}

export async function saveFromReport(templateId: number, reportId: number): Promise<{ id: number }> {
  return json(await fetch(`/api/report-templates/${templateId}/save-from-report/${reportId}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  }))
}
